import OtpInput from 'react-otp-input'
import { Input } from '../../atoms/input'

const inputStyle = {
  width: 50,
  border: '1px solid var(--color-neutral-300)',
  borderRadius: 8,
  color: 'var(--color-neutral-900)',
  padding: '12px 16px',
  margin: '10px 15px',
  fontFamily: 'var(--font-secondary)',
  fontWeight: 'var(--font-regular)',
  fontSize: '16px',
}

const containerStyle = {
  justifyContent: 'center',
  padding: '30px 0 20px 0',
}

export interface PasscodeProps {
  value: string
  handleChange: (val: string) => void
  numInputs?: number
}

export const Passcode = ({
  value,
  handleChange,
  numInputs = 6,
}: PasscodeProps) => (
  <OtpInput
    containerStyle={containerStyle}
    inputStyle={inputStyle}
    numInputs={numInputs}
    onChange={handleChange}
    renderInput={(props) => <Input {...props} />}
    value={value}
    shouldAutoFocus
  />
)
